import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob, IJobType } from './jobs'
import { createConsumeCargoTask } from './taskConsumeCargo'
import { createTask_custom } from './taskCustom'
import { createTask_deliverCargo } from './taskDeliverCargo'
import { createFetchCargoTask } from './taskFetchCargo'
import { ICargoType } from '../entities/cargoesData'
import { jobs } from './jobs-sidecar'

const jobType: IJobType = 'fill-with'
export const register = () => registerJob(jobType, runJob)

export function create(cargoType: ICargoType, onFill: (job: IJob) => boolean) {
  let j = jobs.create('fill-with')
  j.cargoType = cargoType
  j.onFill = onFill
  return j
}

function runJob(job: IJob) {
  jobLogger.assertJobType(job, jobType)

  let m = jobLogger.assertReserved(job)
  let mc = jobLogger.assertMachine(job, (c) => true) // Assert needs this?

  jobLogger.assertTrue(
    job.cargoType !== null && job.cargoType !== 'error',
    'no cargo type!',
  )
  jobLogger.assertTrue(job.onFill != null, 'no onFill!')
  // Seed job tasks
  if (job.tasks.length === 0) {
    job.isFailed = false
    job.tasks = []
    let task = createFetchCargoTask(mc.i, mc.j, null, job.cargoType, true)
    job.tasks.push(task)

    task = createTask_deliverCargo(mc.i, mc.j, job.cargoType, true, false)
    job.tasks.push(task)

    task = createConsumeCargoTask(mc.i, mc.j, job.cargoType)
    job.tasks.push(task)

    task = createTask_custom(mc.i, mc.j, (t) => {
      let result = false
      if (job.onFill) {
        result = job.onFill(job)
      }

      if (!result) {
        jobLogger.failTask(job, t, 'onfail failure')
      } else {
        jobLogger.succeedJob(job)
      }
    })
    job.tasks.push(task)

    return
  }

  advanceTask(job)
}
